import { createStandardAction } from "typesafe-actions";

// eslint-disable-next-line import/prefer-default-export
export const setLoginModalOpen = createStandardAction(
  "SET_LOGIN_MODAL_OPEN"
)<boolean>();
